export const FETCH_DASHBOARD_ANALYTICS = 'FETCH_DASHBOARD_ANALYTICS';
export const FETCH_DASHBOARD_ANALYTICS_SUCCESS = 'FETCH_DASHBOARD_ANALYTICS_SUCCESS';
export const FETCH_DASHBOARD_ANALYTICS_DAYWISE = 'FETCH_DASHBOARD_ANALYTICS_DAYWISE';
export const FETCH_DASHBOARD_ANALYTICS_FAIL = 'FETCH_DASHBOARD_ANALYTICS_FAIL';
export const FETCH_DASHBOARD_ANALYTICS_SKIP = 'FETCH_DASHBOARD_ANALYTICS_SKIP';
export const CLEAR_DASHBOARD_ANALYTICS = 'CLEAR_DASHBOARD_ANALYTICS';

export const fetchDashboardAnalytics = (payload) => ({
  type: FETCH_DASHBOARD_ANALYTICS,
  payload,
});

export const fetchDashboardAnalyticsSuccess = (payload) => ({
  type: FETCH_DASHBOARD_ANALYTICS_SUCCESS,
  payload,
});

export const fetchDashboardAnalyticsDayWise = (payload) => ({
  type: FETCH_DASHBOARD_ANALYTICS_DAYWISE,
  payload,
});

export const fetchDashboardAnalyticsFail = (error) => ({
  type: FETCH_DASHBOARD_ANALYTICS_FAIL,
  payload: error,
});

export const fetchDashboardAnalyticsSkip = () => ({
  type: FETCH_DASHBOARD_ANALYTICS_SKIP,
});

export const clearDashboardAnalytics = () => ({
  type: CLEAR_DASHBOARD_ANALYTICS,
});
